export default function getSchema({ webData, price, resourceData, pageUrl, platform = 'pc' }) {
  const { isMro, productRecord, currentCatalog } = webData || {};

  const {
    productId,
    productCode,
    productName,
    productModel,
    brandName,
    productGradePlateName,
    standard,
    encapsulationModel,
    selfProductCode,
    saleRuleGroupId,
    luceneBreviaryImageUrls,
    stockNumber,
  } = productRecord || {};

  const { projectConfigVO } = resourceData || {};

  const _brandName = brandName || productGradePlateName;

  const _standard = !isEmpty(standard || encapsulationModel) ? `，封装为${standard || encapsulationModel}` : '';

  // 是否预售
  const isPreSale = !selfProductCode && saleRuleGroupId === 10054;

  const images = luceneBreviaryImageUrls?.replace(/product\/breviary/g, 'product/source')?.split('<$>') || [];

  const availability = stockNumber > 0 ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock';

  let title = isMro
    ? `${productName}【价格 采购 图片】-立创MRO工业品`
    : `${productModel}中文资料_最新报价_数据手册下载_${_brandName}-${currentCatalog?.catalogName}-立创商城`;
  if (platform === 'mobile') {
    title = isMro
      ? `${productName}工业品【价格 采购 图片】-立创商城`
      : `${productModel}电子元器件_最新报价_数据手册下载_${_brandName}-立创商城`;
  }

  let description = '';
  if (isMro) {
    description = `${productName}，参考价格￥${price}。免费下载专业资料、手册，有详细的典型应用场景。`;
  } else {
    if (platform === 'mobile') {
      description = `${currentCatalog?.catalogName} ${productModel}由${_brandName}设计生产，立创商城${isPreSale ? '预售' : '现货'}销售，正品保证，参考价格￥${price}${_standard}。专业规格书、详细参数、引脚图、PCB焊盘图，典型应用图，Datasheet数据手册等资料查询和免费下载。`;
    } else {
      description = `${currentCatalog?.catalogName} ${productModel}由${_brandName}设计生产，立创商城${isPreSale ? '预售' : '现货'}销售，正品保证，参考价格￥${price}${_standard}。商城还提供${productModel}专业规格书、详细参数、引脚图、PCB焊盘图，典型应用图，Datasheet数据手册等资料查询和免费下载。`;
    }
  }

  const JsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Product',
    name: `${_brandName} ${productModel}`,
    sku: productCode,
    mpn: productModel,
    brand: _brandName,
    description,
    image: images,
    offers: {
      '@type': 'Offer',
      url: `${projectConfigVO?.lcscItemUrl}/${productId}.html`,
      priceCurrency: 'CNY',
      price,
      itemCondition: 'http://schema.org/NewCondition',
      availability,
      inventoryLevel: stockNumber,
      seller: {
        '@type': 'Organization',
        name: '立创商城',
        url: 'https://www.szlcsc.com',
      },
    },
  };

  const MicroData = (
    <div itemScope itemtype="https://schema.org/Product">
      <meta itemprop="name" content={`${_brandName} ${productModel}`} />
      <meta itemprop="description" content={description} />
      {images.map((item, index) => (
        <meta key={index} itemprop="image" content={item} />
      ))}
      <meta itemprop="sku" content={productCode} />
      <meta itemprop="mpn" content={productModel} />
      <meta itemprop="brand" content={_brandName} />
      <div itemprop="offers" itemScope itemtype="https://schema.org/Offer">
        <meta itemprop="price" content={price} />
        <meta itemprop="priceCurrency" content="CNY" />
        <meta itemprop="availability" content={availability} />
        <div itemprop="seller" itemScope itemtype="https://schema.org/Organization">
          <meta itemprop="name" content="立创商城" />
          <link itemprop="url" href="https://www.szlcsc.com" />
        </div>
      </div>
    </div>
  );

  const SeoData = {
    title,
    description,
    additionalMetaTags: [
      {
        name: 'keywords',
        content: isMro
          ? `${productName},立创商城,工业品采购,MRO`
          : `${productModel},${productModel}中文资料,${productModel}数据手册`,
      },
      {
        property: 'og:type',
        content: 'product',
      },
      {
        property: 'og:site_name',
        content: '立创商城',
      },
      {
        property: 'og:url',
        content: pageUrl,
      },
      {
        property: 'og:product:brand',
        content: _brandName,
      },
    ],
    additionalLinkTags: [
      {
        rel: 'canonical',
        href: pageUrl,
      },
    ],
  };

  if (luceneBreviaryImageUrls?.length > 0) {
    SeoData.additionalMetaTags.push({
      property: 'og:image',
      content: luceneBreviaryImageUrls?.split('<$>')?.[0],
    });
  }

  if (price) {
    SeoData.additionalMetaTags.push({
      property: 'og:product:price',
      content: price,
    });
  }

  return {
    SeoData,
    JsonLd,
    MicroData,
    description,
  };
}

function isEmpty(value) {
  if (value === '-' || !value) {
    return true;
  }
  return false;
}
